import { message } from 'antd';
import axios from 'axios';

export const baseUrl = import.meta.env.VITE_APP_BASE_URL
// export const baseUrl = "http://192.168.1.38:8080/api/super-admin"


const axiosInstance = axios.create({
    baseURL: baseUrl || "",
    timeout: 10000,
});

axiosInstance.postWithBody = (url, body, config = {}) => {
    const isFormData = body instanceof FormData;
    return axiosInstance.post(url, body, {
        ...config,
        headers: {
            ...(config.headers || {}),
            'Content-Type': isFormData ? 'multipart/form-data' : 'application/json',
        },
    });
};
axiosInstance.deleteWithBody = (url, body, config = {}) => {
    return axiosInstance.request({
        method: 'DELETE',
        url,
        ...config,
        data: body,
    });
};

axiosInstance.getWithParams = (url, params) => {
    return axiosInstance.get(url, { params });
};

axiosInstance.postWithBody = (url, body, config = {}) => {
    return axiosInstance.post(url, body, config);
};

axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");
        if (token) {
            config.headers.Authorization = token;
        } else {
            console.log('No token found!');
        }
        return config;
    },
    (error) => Promise.reject(error)
);

export const setAxiosInterceptors = () => {
    axiosInstance.interceptors.response.use(
        (response) => {
            const { config, status, data } = response;
            if (["post", "put", "delete"].includes(config.method)) {
                if (status === 201 || status === 200) {
                    if (config.data instanceof FormData) {
                        config.data = new FormData();
                    }
                    message.success(data?.message || "Action successful");
                    console.warn("create successfull")
                }
            }

            return response;
        },
        (error) => {
            if (error.response
            ) {
                const { status, data } = error.response;

                if (status === 401) {
                    message.error("Unauthorized. Please log in again.");
                    window.location.href = "/login";
                } else if (status === 400 || status === 403) {
                    message.error(data?.data || "Request not allowed.");
                } else if (status >= 500) {
                    message.error("Server error. Try again later.");
                } else {
                    message.error(data?.message || "Something went wrong.");
                }
            } else {
                message.error("Network error. Please check your connection.");
            }
            return Promise.reject(error);
        }
    );
};

export default axiosInstance;
